<div class="d-flex flex-column gap-3" data-testid="features-panel">
  <div class="d-flex flex-wrap align-items-start justify-content-between gap-3">
    <div class="d-flex flex-column gap-1">
      <h3 class="av-section-title m-0">{{ 'backoffice.plans.features.title' | translate }}</h3>
      <p class="av-meta m-0" data-testid="features-hint">
        {{ 'backoffice.plans.features.hint' | translate }}
      </p>
    </div>

    @if (facade.canWrite()) {
      <div class="d-flex gap-2">
        <button
          type="button"
          class="av-btn av-btn-primary"
          [disabled]="!isDirty() || facade.isMutating()"
          (click)="save()"
        >
          <mat-icon aria-hidden="true">save</mat-icon>
          {{ 'backoffice.plans.features.save' | translate }}
        </button>

        <button
          type="button"
          class="av-btn"
          [disabled]="!isDirty() || facade.isMutating()"
          (click)="reset()"
        >
          {{ 'backoffice.common.actions.reset' | translate }}
        </button>
      </div>
    }
  </div>

  @if (!facade.canWrite()) {
    <p class="av-meta m-0" data-testid="features-restricted">
      {{ 'backoffice.plans.list.restricted_note' | translate }}
    </p>
  }

  @switch (facade.featuresState()) {
    @case ('error') {
      <av-empty-state
        icon="error_outline"
        [title]="'backoffice.plans.features.error.title' | translate"
        [message]="'backoffice.plans.features.error.message' | translate"
      ></av-empty-state>
    }
    @case ('ready') {
      @if (isEmpty()) {
        <av-empty-state
          icon="checklist"
          [title]="'backoffice.plans.features.empty.title' | translate"
          [message]="'backoffice.plans.features.empty.message' | translate"
        ></av-empty-state>
      } @else {
        <div class="table-scroll">
          <table class="av-table w-100" data-testid="feature-matrix">
            <thead>
              <tr>
                <th scope="col">
                  {{ 'backoffice.plans.features.columns.feature' | translate }}
                </th>
                <th scope="col">
                  {{ 'backoffice.plans.features.columns.category' | translate }}
                </th>
                <th scope="col">{{ 'backoffice.plans.features.columns.grant' | translate }}</th>
                <th scope="col">{{ 'backoffice.plans.features.columns.current' | translate }}</th>
              </tr>
            </thead>

            <tbody>
              @for (feature of facade.features(); track feature.id) {
                <tr [attr.data-feature]="feature.key">
                  <td>
                    <div class="d-flex flex-column">
                      <span class="cell-strong">{{ feature.key }}</span>
                      @if (feature.key === agentKey) {
                        <span class="av-meta" data-testid="agent-feature-consequence">
                          {{ 'backoffice.plans.features.agent_consequence' | translate }}
                        </span>
                      }
                    </div>
                  </td>

                  <td class="cell-muted">{{ feature.categoryLabel }}</td>

                  <td>
                    <label class="d-flex align-items-center gap-2">
                      <input
                        type="checkbox"
                        [checked]="isSelected(feature)"
                        [disabled]="!facade.canWrite() || facade.isMutating()"
                        (change)="toggle(feature)"
                      />
                      <span class="av-meta">
                        {{
                          (isSelected(feature)
                            ? 'backoffice.plans.features.granted'
                            : 'backoffice.plans.features.absent'
                          ) | translate
                        }}
                      </span>
                    </label>
                  </td>

                  <td>
                    <av-status-chip
                      [label]="
                        (feature.granted
                          ? 'backoffice.plans.features.granted'
                          : 'backoffice.plans.features.absent'
                        ) | translate
                      "
                      [tone]="feature.granted ? 'positive' : 'neutral'"
                    ></av-status-chip>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    }
    @default {
      <av-empty-state
        icon="hourglass_empty"
        [title]="'backoffice.plans.features.loading.title' | translate"
        [message]="'backoffice.plans.features.loading.message' | translate"
      ></av-empty-state>
    }
  }
</div>
